export const getCarIdSelector = (state, adId) => {
    if (adId) {
        return (
            (state?.items?.elements[adId]?.inspection_info?.carId
                || state?.myZone?.adsData[adId]?.inspectionInfo?.carId)
            ?? null
        );
    }
    return null;
};

export const getCarTitleSelector = (state, adId) => {
    if (adId) {
        return (state?.items?.elements[adId]?.title || state?.myZone?.adsData[adId]?.title) ?? null;
    }
    return null;
};
